<template>
  <div>
    <a href="javascript:;" @click="addPakcage">
      <Icon type="ios-add-circle-outline" size="30" color="#C5C5C5" />
    </a>
    <Modal v-model="modalShow" width="760" @on-ok="modalConfirm" @on-cancel="modalCancel">
      <p slot="header" style="text-align:center;font-size:15px">
        <Icon type="ios-information-circle"></Icon>
        <span>关联课包</span>
      </p>

      <el-form :inline="true" :model="formPkg" label-width="90px">
        <el-form-item label="课程ID:">
          <el-input v-model="formPkg.id" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="课程名称: ">
          <el-input v-model="formPkg.name" style="width:150px"></el-input>
        </el-form-item>
        <el-form-item label="级别:" label-width="50px">
          <el-input v-model="formPkg.level" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onQuery">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable2"
        :data="queryData"
        stripe
        border
        tooltip-effect="dark"
        style="width: 100%"
        @current-change="handleSelect"
        class="elTable" 
      >
        <el-table-column label width="80" align="center">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="tempRadio">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="课程ID" align="center" width="90">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewPackage(scope.row)"
              style="color:#1d90e6"
            >{{ scope.row.id }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="课程名称" align="center" min-width="130">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewPackage(scope.row)"
              style="color:#1d90e6"
            >{{ scope.row.name }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="level" label="级别" align="center" width="90"></el-table-column>
        <el-table-column prop="period" label="类型" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.period==1">日课程</span>
            <span v-else-if="scope.row.period==2">周课程</span>
            <span v-else-if="scope.row.period==3">月课程</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="内容数量" align="center" width="100"></el-table-column>
        <el-table-column prop="" label="上架状态" width="120" align="center">
          <template slot-scope="scope">
             <el-tag v-if="scope.row.enabled == true" type="success"
              >已上架</el-tag
            >
            <el-tag v-else-if="scope.row.enabled == false" type="danger"
              >已下架</el-tag
            >
            <!-- <el-select v-model="scope.row.enabled" size="mini" disabled>
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "classAddPackage",
  components: {},
  data() {
    return {
      modalShow: false,
      formPkg: {
        id: "",
        name: "",
        level: "",
      },
      queryData: [],
      tempRadio: "",
      pageTotal: 0,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      statusList: [
        {
          value: 1,
          label: "已上架",
        },
        {
          value: 2,
          label: "已下架",
        },
      ],
      pkgId: "",
    };
  },
  props: {
  },
  created() {
    this.fetchPackageList();
  },
  watch: {},
  methods: {
    fetchPackageList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        packageType:0
      };
      if (this.formPkg.id != "") {
        params.id = this.formPkg.id;
      }
      if (this.formPkg.name != "") {
        params.name = this.formPkg.name;
      }
      if (this.formPkg.level != "") {
        params.level = this.formPkg.level;
      }
      params.packageType = 0
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.queryData = m.list;
          this.pageTotal = m.pager.total;
        }
        this.loading = false;
      });
    },
    addPakcage() {
      this.modalShow = true;
    },
    modalConfirm() {
      console.log(this.tempRadio);
      let pkgName = "";
      let pkgLevel = "";
      let pkgCount = "";
      let pkgRemark = "";
      let image = "";
      this.pkgId = `${this.tempRadio}`;
      for (let i in this.queryData) {
        if (this.pkgId == this.queryData[i].id) {
          pkgName = this.queryData[i].name;
          pkgLevel = this.queryData[i].level;
          image = this.queryData[i].image;
          pkgCount = this.queryData[i].count;
          pkgRemark = this.queryData[i].remark;
        }
      }
      this.$emit("addPkg", {
        pkgId: this.pkgId,
        pkgName: pkgName,
        pkgLevel: pkgLevel,
        image: image,
        pkgCount: pkgCount,
        pkgRemark: pkgRemark,
      });
    },
    modalCancel() {
      this.modalShow = false;
    },
    onQuery() {
      this.queryParams.page  = 1
      this.fetchPackageList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchPackageList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchPackageList();
    },
    viewPackage(pkg) {},
    handleSelect(val) {},
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (address.indexOf("package_del") == -1) {
                resolve(JSON.stringify(response.data.data));
              } else {
                resolve(JSON.stringify(response.data.msg));
              }
            } else {
              alert(response.data.rc + ". " + response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// classAddPackage.vue?4ff48359